<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Le4uAj/tc-custom/9781250021311.jpg?1719374967834" alt="This image is the cover for the book Boston Mob"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Boston Mob
      </h1>
      <p class="bookDescription body article font2">
        <p>The New England Mafia was a hugely powerful organization that survived by using violence to ruthlessly crush anyone that threatened it, or its lucrative gambling, loansharking, bootlegging and other enterprises. Psychopathic strongman Joseph "The Animal" Barboza was one of the most feared mob enforcers of all time, killing as many as thirty people for business and pleasure.<br/><br/>From information based on newly declassified documents and the use of underworld sources, <i>Boston Mob</i> spans the gutters and alleyways of East Boston, Providence and Charlestown to the halls of Congress in Washington D.C. and Boston's Beacon Hill. Its players include governors and mayors, and the Mafia Commission of New York City. From the tragic legacy of the Kennedy family to the Winter Hill-Charlestown feud, the fall of the New England Mafia and the rise of Whitey Bulger, Mark Songini's <i>Boston Mob </i>is a saga of treachery, murder, greed, and the survival of ruthless men pitted against legal systems and police forces.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marc Songini
      </h2>
      
      <p class="authorDescription body article"><P>MARC SONGINI is a Boston-area journalist whose work has appeared in the <I>Boston Herald</I>, the <I>Boston Globe </I>and numerous other major publications. He is also the acclaimed author of <I>The Lost Fleet,</I> a chronicle of Yankee whaling and disaster at sea.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9653f2aa